import {styled} from '@mui/material/styles';
import React from 'react';

import {InfoRoundedIcon} from '../../constants/icons';
import CustomToolTip from '../CustomToolTip/CustomToolTip';

const StyledInfoIcon = styled(InfoRoundedIcon)(({theme, color}) => ({
  width: 14,
  marginLeft: theme.spacing(0.15),
  '& path': {
    fill: color === 'primary' ? theme.palette.primary.main : theme.palette.secondary.main,
  },
  '&:hover': {
    cursor: 'pointer',
  },
}));

const StyledIconWrapper = styled('span')(({theme}) => ({
  display: 'inline-block',
  height: 14,
}));

export default function InfoTooltip({information, placement = 'top-end', color}) {
  return (
    <CustomToolTip title={information} placement={placement} arrow={true}>
      <StyledIconWrapper>
        <StyledInfoIcon color={color} />
      </StyledIconWrapper>
    </CustomToolTip>
  );
}
